var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-loader"},[_c('span',{staticClass:"loader"},[_c('span',{staticClass:"r r1"}),_c('span',{staticClass:"r r2"}),_c('span',{staticClass:"r r3"}),_c('span',{staticClass:"r r4"}),_c('span',{staticClass:"r r5"}),_c('span',{staticClass:"logo"},[_c('svg-sprite',{attrs:{"width":"130","height":"31","icon-id":"logo"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }